// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2kftU","title":"FrontImage_title__3bc4R"};